// extracted by mini-css-extract-plugin
export default {"footer_disclaimer":"FooterDisclaimer-module__footer_disclaimer--JcRDe"};